import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getHomeCitySlice = createSlice({
  name: "getHomeCity",
  initialState,
  reducers: {
    getHomeCityStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getHomeCitySuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getHomeCityFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getHomeCityStart,
  getHomeCitySuccess,
  getHomeCityFailure,
  clearError,
  clearMessage,
} = getHomeCitySlice.actions;

export default getHomeCitySlice.reducer;
